import { render, staticRenderFns } from "./ReviewSuggestions.vue?vue&type=template&id=fc7ec644&scoped=true&"
import script from "./ReviewSuggestions.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewSuggestions.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ReviewSuggestions.vue?vue&type=style&index=0&id=fc7ec644&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7ec644",
  null
  
)

export default component.exports